// import { IoHeart, IoHeartOutline } from "react-icons/io5";
// import { useState } from "react";
// import Card from "components/card";

// const SocialMediaCard = ({
//   title,
//   description,
//   price,
//   image,
//   bidders,
//   extra,
//   comments,
// }) => {
//   const [heart, setHeart] = useState(true);
//   return (
//     <Card
//       extra={`flex flex-col w-full h-full min-h-[240px] !p-4 3xl:p-![18px] bg-white ${extra}`}
//     >
//       <div className="h-full w-full">
//         <div className="relative w-full">
//           <img
//             src={image}
//             className="mb-3 h-[150px] object-cover w-full rounded-xl 3xl:h-full 3xl:w-full"
//             alt=""
//           />
//           <button
//             onClick={() => setHeart(!heart)}
//             className="absolute right-3 top-3 flex items-center justify-center rounded-full bg-white p-2 text-brand-500 hover:cursor-pointer"
//           >
//             <div className="flex h-full w-full items-center justify-center rounded-full text-xl text-navy-900 hover:bg-gray-50">
//               {heart ? (
//                 <IoHeartOutline />
//               ) : (
//                 <IoHeart className="text-brand-500" />
//               )}
//             </div>
//           </button>
//         </div>

//         <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
//           <div className="mb-2">
//             <p className="text-lg font-bold text-white"> {title} </p>
//             <p className="mt-1 text-sm font-medium text-gray-600 md:mt-2 line-clamp-4">
//               {description}{" "}
//             </p>
//           </div>

//           {/* <div className="flex flex-row-reverse md:mt-2 lg:mt-0">
//             <span className="z-0 ml-px inline-flex h-8 w-8 items-center justify-center rounded-full border-2 border-white bg-[#E0E5F2] text-xs text-navy-700 !border-navy-800 bg-gray-800 text-white">
//               +5
//             </span>
//             {bidders?.map((avt, key) => (
//               <span
//                 key={key}
//                 className="z-10 -mr-3 h-8 w-8 rounded-full border-2 border-white !border-navy-800"
//               >
//                 <img
//                   className="h-full w-full rounded-full object-cover"
//                   src={avt}
//                   alt=""
//                 />
//               </span>
//             ))}
//           </div> */}
//         </div>

//         <div className="flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
//           <div className="block">
//             <p className="mb-2 text-sm font-bold text-white">
//               Likes: {price} <span></span>
//             </p>
//             <p className="mb-2 text-sm font-bold text-white">
//               Comments: {comments} <span></span>
//             </p>
//           </div>

//           <button
//             href=""
//             className="linear rounded-[20px] bg-brand-400 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-300 active:bg-brand-700 active:opacity-90"
//           >
//             Delete
//           </button>
//         </div>
//       </div>
//     </Card>
//   );
// };

// export default SocialMediaCard;

import { IoHeart, IoHeartOutline, IoChatbubbleOutline, IoTrashOutline } from "react-icons/io5";
import { useRef, useState } from "react";
import Card from "components/card";
import Modal from "./Modal";
import PostService from "services/post.service";
import Toast from "components/toaster";

const SocialMediaCard = ({
  title,
  description,
  price,
  image,
  bidders,
  extra,
  comments,
  getAllPosts,
}) => {
  const activateRef = useRef();
  const [heart, setHeart] = useState(true);
  const [isDeleteModel, setIsDeleteModel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  // Parse the files array to get the first file's data
  const getImageData = () => {
    if (image?.files && image.files.length > 0) {
      const firstFile = image.files[0];
      
      // Check if it's a JSON string that needs parsing
      if (typeof firstFile === 'string' && firstFile.startsWith('{')) {
        try {
          const parsedFile = JSON.parse(firstFile);
          return parsedFile;
        } catch (error) {
          console.error('Error parsing file data:', error);
          return null;
        }
      }
      
      // If it's a direct URL string, return it as is
      if (typeof firstFile === 'string' && (firstFile.startsWith('http') || firstFile.startsWith('https'))) {
        return { url: firstFile };
      }
      
      // If it's already an object, return it directly
      if (typeof firstFile === 'object') {
        return firstFile;
      }
    }
    return null;
  };

  const imageType = getImageData() || image?.account?.profilepic;

  const handleMediaClick = () => {
    setMediaType("image");
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const onToggle = () => {
    try {
      setConfirmLoader(true);
      const response = PostService.deletePost({ post_id: image._id });
      setConfirmLoader(false);
      setIsDeleteModel(false);
      setTimeout(() => {
        getAllPosts();
      }, 200);
      Toast("success", "Post delete successfully");
    } catch (error) {
      Toast("error", error.response.data.message);
    }
  };

  const handleOpenDeleteModel = () => {
    setIsDeleteModel(true);
  };

  return (
    <>
      <Card
        extra={`flex flex-col w-full h-full min-h-[210px] !p-4 3xl:p-![18px] bg-white ${extra}`}
      >
        <div className="flex h-full w-full flex-col">
          <div className="relative w-full">
            {imageType?.thumbnail_url ? (
              <img
                src={imageType.thumbnail_url}
                className="mb-2.5 h-[130px] w-full cursor-pointer rounded-xl object-cover 3xl:h-[300px] 3xl:w-full"
                alt=""
                onClick={handleMediaClick}
              />
            ) : imageType?.url ? (
              <img
                src={imageType.url}
                className="mb-2.5 h-[130px] w-full cursor-pointer rounded-xl object-cover 3xl:h-[290px] 3xl:w-full"
                alt=""
                onClick={handleMediaClick}
              />
            ) : (
              <img
                src={imageType}
                className="mb-2.5 h-[130px] w-full cursor-pointer rounded-xl object-cover 3xl:h-[290px] 3xl:w-full"
                alt=""
                onClick={handleMediaClick}
              />
            )}
            {/* <button
            onClick={() => setHeart(!heart)}
            className="absolute right-3 top-3 flex items-center justify-center rounded-full bg-white p-2 text-brand-500 hover:cursor-pointer"
          > */}
            {/* <div className="flex h-full w-full items-center justify-center rounded-full text-xl text-navy-900 hover:bg-gray-50">
              {heart ? (
                <IoHeartOutline />
              ) : (
                <IoHeart className="text-brand-500" />
              )}
            </div> */}
            {/* </button> */}
          </div>

          <div className="mb-2.5 flex flex-grow flex-col justify-between px-1">
            <div className="mb-1.5">
              <p className="text-lg font-bold text-white"> {title} </p>
              <p
                className="mt-1 line-clamp-3 text-sm font-medium text-gray-600 md:mt-1.5"
                title={description}
              >
                {description}{" "}
              </p>
            </div>
          </div>

          <div className="mt-auto flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-1.5">
                <IoHeart className="h-4 w-4 text-white" />
                <p className="text-sm font-bold text-white">
                  {price}
                </p>
              </div>
              <div className="flex items-center gap-1.5">
                <IoChatbubbleOutline className="h-4 w-4 text-white" />
                <p className="text-sm font-bold text-white">
                  {comments}
                </p>
              </div>
            </div>

            <button
              className="flex items-center justify-center rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 p-1.5 text-red-500 transition-all duration-200 hover:bg-red-500/20 hover:border-red-400/50 hover:text-red-600 active:scale-95"
              onClick={handleOpenDeleteModel}
            >
              <IoTrashOutline className="h-4 w-4" />
            </button>
          </div>
        </div>
      </Card>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative max-h-[calc(100vh-20px)] w-fit max-w-3xl rounded-xl bg-white shadow-lg">
            <button
              className="absolute right-5 top-2 text-xl font-bold text-navy-800 hover:text-gray-900"
              onClick={closeModal}
            >
              ✕
            </button>
            <div className="flex justify-center px-4 pb-4 pt-10">
              <img
                src={imageType?.thumbnail_url || imageType?.url || imageType}
                alt=""
                className="h-[500px] w-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      <Modal
        isOpen={isDeleteModel}
        onClose={() => {
          setIsDeleteModel(false);
          document.body.style.overflow = "unset";
        }}
        isActive={imageType}
        onToggle={onToggle}
        activateRef={activateRef}
        confirmLoader={confirmLoader}
      />
    </>
  );
};

export default SocialMediaCard;
